<template>
  <div>
    <rx-summary-card-pair
      :showCrosses="false"
      :includeSphereEquiv="includeSphereEquiv"
      :rxs="rxs"
    >
      <template v-slot:content_od>
        <v-scale-transition>
          <trial-suggestion-card
            class="my-2"
            :data="result.od"
            v-if="result.od"
            eye="od"
          ></trial-suggestion-card>
        </v-scale-transition>
      </template>
      <template v-slot:content_os>
        <v-scale-transition
          ><trial-suggestion-card
            class="my-2"
            v-if="result.os"
            :data="result.os"
            eye="os"
          ></trial-suggestion-card>
        </v-scale-transition>
      </template>
    </rx-summary-card-pair>
    <div v-if="(rxs && !result.od) || !result.os" class="text-center my-4">
      <v-btn
        @click="manualTrigger()"
        small
        outlined
        color="primary"
        class="mx-auto"
      >
        <v-icon class="mr-2">mdi-refresh</v-icon>Find Trials for this Rx</v-btn
      >
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import RxMethods from "@/assets/js/cls/RxMethods";
import { mapState } from "vuex";

export default {
  name: "TrialSuggestions",
  components: {
    RxSummaryCardPair: () => import("@/components/clStuff/RxSummaryCardPair"),
    TrialSuggestionCard: () =>
      import("@/components/clStuff/TrialSuggestionCard"),
  },
  mixins: [RxMethods],
  props: {
    lensID: {
      type: Number,
      required: true,
    },
    includeSphereEquiv: {
      type: Boolean,
      default: false,
    },
    rxs: null,
  },
  data: function () {
    return {
      // currentParamString: { od: null, os: null },
      result: { od: null, os: null },
    };
  },
  methods: {
    startPowerSearch() {
      // console.log("starting power search");
      if (!this.rxs) return null;
      this.callPowerApi("od");
      this.callPowerApi("os");
    },
    callPowerApi(eye) {
      if (!this.rxs || !this.lensID) {
        console.log(
          "no rx or lens ID provided for lens suggestion API for " + this.eye
        );
        return;
      }
      let rxParamString = this.rxHash(this.rxs[eye]);
      ApiServices.bestPowerForLensIdAPI(this.lensID, rxParamString)
        .then((response) => {
          this.result[eye] = response.data;
        })
        .catch((e) => {
          // alert(e);
          console.log("Error loading lens power data");
          console.log(e);
        });
    },
    manualTrigger() {
      this.callPowerApi("od");
      this.callPowerApi("os");
    },
  },
  computed: {
    ...mapState(["loggedIn", "subscriber"]),
  },
  watch: {
    rxs: {
      handler: "startPowerSearch",
      deep: true,
    },
    lensID: {
      handler: "startPowerSearch",
    },
  },
  mounted() {
    // console.log("rxs", this.rxs);
    if (this.lensID && this.rxs) this.startPowerSearch();
  },
};
</script>

<style scoped></style>
